import type { StorageArea, Options } from './types';

const FEATURE_UNIQ_KEY = '__storageSync__';
const UNAUTHORIZED_USER = '__unauthorizedUser__';

const STORAGE_LOCAL: StorageArea = 'local';
const STORAGE_SESSION: StorageArea = 'session';

const DEFAULT_OPTIONS: Options = {
    storage: STORAGE_LOCAL,
    ttlMs: 2 * 24 * 60 * 60 * 1000, // 2 days
    saveDebounceMs: 2 * 1000, // 2 sec
    cleanupOnStartup: true,
    renewOnInitialRead: false,
    renewOnMigrationFromUnauthorized: true,
    syncByStorageSignal: false,
};

const defaultExtractProcessor = <T>(data: unknown): T => data as T;
const defaultSaveProcessor = <T>(data: T): unknown => data;

export {
    FEATURE_UNIQ_KEY,
    UNAUTHORIZED_USER,
    STORAGE_LOCAL,
    STORAGE_SESSION,
    DEFAULT_OPTIONS,
    defaultExtractProcessor,
    defaultSaveProcessor,
};
